export class Delegator {
    static delegate(base, delegate, property) {
        const descriptors = Object.getOwnPropertyDescriptors(delegate.prototype);
        const names = Object.keys(descriptors);
        for (let i = 0, n = names.length; i < n; i++) {
            const name = names[i];
            if (name !== "constructor") {
                this.delegateProperty(name, descriptors[name], base.prototype, property);
            }
        }
    }
    static delegateProperty(name, descriptor, obj, objProperty) {
        const proxyDescriptor = Object.assign({}, descriptor);
        if (proxyDescriptor.get) {
            proxyDescriptor.get = function () {
                return this[objProperty][name];
            };
        }
        if (proxyDescriptor.set) {
            proxyDescriptor.set = function (v) {
                this[objProperty][name] = v;
            };
        }
        if (proxyDescriptor.value && proxyDescriptor.value instanceof Function) {
            proxyDescriptor.value = function (...args) {
                return this[objProperty][name](...args);
            };
        }
        Object.defineProperty(obj, name, proxyDescriptor);
    }
}
//# sourceMappingURL=Delegator.js.map